import React from 'react';
import { FormControlLabel, makeStyles, Switch } from '@material-ui/core';
import muiSwitchStyles from 'styles/muiSwitchStyle';

const MuiSwitch = ({ input, label }) => {
  const switchStyles = muiSwitchStyles({});
  const classes = useStyles();
  return (
    <FormControlLabel
      className={classes.label}
      control={
        <Switch
          className={switchStyles.switch}
          checked={!!input.value}
          onChange={input.onChange}
          name={input.name}
          color="primary"
        />
      }
      data-testid={input.name}
      label={label}
    />
  );
};

const useStyles = makeStyles(() => ({
  label: {
    marginLeft: 0,
    height: '100%'
  }
}));

export default MuiSwitch;
